<template>
    <div class="payInfo">
        <div class="payInfoDetail">
            <div class="payInfoImg">
                <img src="../../assets/images/personalCenter/info.png" alt="">
            </div>
            <p>出票完成</p>
        </div>
        <div class="goodsItem" v-for="(goodsItem,index) in ticketsStatusInfo" :key="index">
            <div>
                <!-- <img src="../../assets/images/xuebi_24.png"> -->
                <img :src="weburl + goodsItem.original_img">
            </div>
            <div>
                <p>{{goodsItem.goods_name}}</p>
                <p>使用时间：<span>{{handleUseTimeFormat(goodsItem.occ_date)}}</span></p>
                <span :class="{succeedDrawABill:goodsItem.goods_status==8,fallDrawABill:goodsItem.goods_status!=8}">{{goodsItem.goods_status | transitionGoodStatus}}</span>
            </div>
            <div>
                <p>X{{goodsItem.goods_num}}</p>
            </div>
        </div>
        <div class="info_remind">
            <p>系统已将取票凭证码</p>
            <p>发送到您的联系手机{{userMobileNum}}</p>
            <p>请注意查收短信！</p>
        </div>
        <p>温馨提示：所有酒店订单都需要经过二次确认，付款成功后请联系工作人员确认订单，感谢您的配合；如需改期、退款请提前申请或者拨打客服热线：0757-27331641/1642
            工作时间：8：30-18:30</p>
        <p>联系电话：<a href="tel:0575-27331641">0575-2733</a>/<a href="tel:27331642">27331642</a></p>
        <p>如需改期，请致电联系<a href="tel:0757-27001641">0757-27001641</a>，入住当天不可退换，给您带来不变敬请谅解！</p>
        <div class="infoBtn">
            <span @click="continueBuy()">继续购票</span>
            <span @click="lookOrder()">查看订单</span>
        </div>

    </div>
</template>

<script>
export default {
  name: "payInfo",
  data: function() {
    return {
      order_sn: this.$route.query.order_sn,
      order_id: this.$route.query.order_id,
      ticketsStatusInfo: "",
      userMobileNum: ""
    };
  },
  inject: ["showMsg"],
  created: function() {
    this.showMsgInfoBox();
    this.getGoodStatusInfo();
    this.$store.commit("set_current", 6);
    this.$store.commit("set_title", "支付成功");
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    },
    hurl: function() {
      return this.$store.state.hurl;
    }
  },
  filters: {
    transitionGoodStatus: function(val) {
      if (val == 8) {
        return "出票成功";
      } else {
        return "出票失败（请联系客服）";
      }
    }
  },
  methods: {
    // 继续购票
    continueBuy: function() {
      this.$router.push({ path: "/market" });
    },
    // 查看订单
    lookOrder: function() {
      this.$router.push({ path: "/myOrder" });
    },
    showMsgInfoBox() {
      if(this.$route.query.order_type == 848){
          this.$msgbox({
              content:
                  "<div  style='height: 40px;width: 40px;margin:0 auto 10px; background: url(../../../static/img/this.showMsg.png) no-repeat ; background-size: 40px auto; ' ></div><p style=' text-align: center; line-height: 20px;font-size: 1rem;'>如您购买年卡类商品，年卡的指定需要10个工作日，请上传年卡资料，并致电 <a href='tel:0757-27331641' style='color:#282828;'>0757-27331641</a>制作年卡</p>",
              confirm: "资料上传",
              className: "pop-custom"
          })
              .then(() => {
                  this.$router.push({ path: "/myOrder" });
              })
              .catch(err => {
                  console.log("error");
              });
      }

    },
    // 获取出票结果的数据
    getGoodStatusInfo: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/Api/check_order_tickets_status",
        dataType: "json",
        data: {
          order_id: this.$route.query.order_id
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.ticketsStatusInfo = res.data.result;
            this.userMobileNum = res.data.result[0].userMobileNum;
            // this.userMobileNum = JSON.parse(localStorage.getItem("userMobileNum"));
          } else {
            this.showMsg("出票异常，请稍后再试");
          }
        })
        .catch(() => {
          this.showMsg("网络错误，请稍后再试");
        });
    },
    // 处理服务器返回来的“使用时间”数据格式的方法
    handleUseTimeFormat: function(time) {
      var formatTime = new Date(time * 1000);
      var formatTimeY = formatTime.getFullYear();
      var formatTimeM = formatTime.getMonth() + 1;
      var formatTimeD = formatTime.getDate();
      formatTime = formatTimeY + "-" + formatTimeM + "-" + formatTimeD;
      return formatTime;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common";

.payInfo {
  font-size: @font;
  // padding: 0 8%;
  .payInfoDetail {
    text-align: center;
    padding: 15px 0 0;
    .payInfoImg {
      width: 65px;
      height: 65px;
      margin: auto;
      img {
        width: @width;
      }
    }
    p {
      margin: 15px 0;
      // padding: 0.8%;
    }
  }
  .info_remind {
    border: 1px solid @brick_red;
    .border-radius(10px);
    // width: @width;
    width: 80%;
    margin: 0 auto 15px;
    text-align: center;
    .box-sizing;
    padding: 15px;
    line-height: 24px;
  }
  & > p {
    font-size: 0.9rem;
    line-height: 20px;
    // padding: 0.8%;
    margin: 0.8% 20px;
    a {
      color: #282828;
    }
  }
  .infoBtn {
    display: flex;
    justify-content: space-around;
    margin: 20px 0;
    span {
      width: 35%;
      .btn;
      &:first-child {
        background: @subject_color;
      }
    }
  }
}
.goodsItem {
  width: 100%;
  height: 90px;
  background-color: #f9f9f9;
  display: flex;
}
.goodsItem div:nth-child(1) {
  width: 30%;
  height: 100%;
  line-height: 100%;
  text-align: center;
  // background-color: red;
}
.goodsItem div:nth-child(1) img {
  width: 90%;
  position: relative;
  top: 16%;
}
.goodsItem div:nth-child(2) {
  width: 60%;
  height: 100%;
  // background-color: green;
}
.goodsItem div:nth-child(2) p:nth-child(1) {
  margin-top: 12px;
  color: #272727;
}
.goodsItem div:nth-child(2) p:nth-child(2) {
  margin-top: 3px;
  color: #7c7b81;
}
.fallDrawABill {
  position: relative;
  top: 17px;
  color: #fb7c0c;
}
.succeedDrawABill {
  position: relative;
  top: 17px;
  color: #417ff6;
}
.goodsItem div:nth-child(3) {
  width: 10%;
  height: 100%;
  // background-color: blue;
}
.goodsItem div:nth-child(3) p {
  text-align: center;
  margin-top: 15px;
}
</style>
